import { Roles } from '../constants.js';

export default {
    path: '/student',
    component: () => import('@/views/StudentDashboard.vue'),
    name: 'StudentDashboard',
    meta: { requiresAuth: true, role: Roles.STUDENT },
};
